import * as consts from './consts'

/**
 */
export const actionName = (name) => `${consts.ACTION_PREFIX}${name}`

/**
 */
export const info = require('debug')('module:property:info')

/**
 */
export const filterByPropertyType = (propertyType) => (v) => {
  if (propertyType) {
    return v.propertyType === propertyType
  }
  return true
}
